var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('calendar-task',{staticStyle:{"background-color":"white"},attrs:{"date":_vm.date},on:{"date-change":_vm.dateChange,"item-click":_vm.itemClick},model:{value:(_vm.calendarData),callback:function ($$v) {_vm.calendarData=$$v},expression:"calendarData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }